module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-1312-retro-min.d5c623db.jpg";